import { useEffect } from 'react';
import { blockAutoUpdate, unblockAutoUpdate } from '../../services/updateManager';

interface Props {
  // Identificador único de motivo de bloqueo. Permite varios bloqueos
  // simultáneos sin pisarse (set interno). Ej: "editing-detail".
  reason: string;
}

// Bloquea la auto-actualización mientras esté montado. Si hay un SW
// nuevo esperando, no se aplicará hasta que se desmonten todos los
// BlockAutoUpdate y la cola offline esté vacía.
export function BlockAutoUpdate({ reason }: Props) {
  useEffect(() => {
    blockAutoUpdate(reason);
    return () => unblockAutoUpdate(reason);
  }, [reason]);
  return null;
}
